/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { useLayout } from '../../core'
import { AsideMenu } from './AsideMenu'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../setup'
import { KTSVG } from '../../../helpers'

const AsideDefault: FC = () => {
  const { config, classes } = useLayout()
  const { aside } = config
  const { configurations }: any = useSelector<RootState>(
    (state) => ({
      configurations: state.configuration.configurations,
    }),
    shallowEqual,
  );

  const sidebarToggle = () => {
    const hoverClass: string = "aside-hoverable";
    setTimeout(() => {
      if (document.getElementsByTagName('body')?.[0].hasAttribute("data-kt-aside-minimize")) {
        const element = document.getElementById("kt_aside");
        if (element) {
          const updatedClass: string = element.className.replace(hoverClass, '') || '';
          element.className = updatedClass;
          setTimeout(() => {
            element.className = updatedClass + " " + hoverClass;
          }, 1000);
        }
      }
    }, 100);
  }

  return (
    <div
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
    >
      {/* begin::Brand */}
      <div className='aside-logo flex-column-auto' id='kt_aside_logo'>
        {/* begin::Logo */}
        {aside.theme === 'dark' && (
          <Link to='/dashboard'>
            <img src={config && configurations?.logo} alt=""
              className='h-40px logo' />
          </Link>
        )}
        {aside.theme === 'light' && (
          <Link to='/dashboard'>
            <img src={config && configurations?.logo} alt=""
              className='h-40px logo' />
          </Link>
        )}
        {/* end::Logo */}

        {/* begin::Aside toggler */}
        {aside.minimize && (
          <div
            id='kt_aside_toggle'
            className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
            onClick={sidebarToggle}
          >
            <KTSVG
              path={'/media/icons/duotune/arrows/arr080.svg'}
              className={'svg-icon-1 rotate-180'}
            />
          </div>
        )}
        {/* end::Aside toggler */}
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className='aside-menu flex-column-fluid'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
      {/* end::Aside menu */}

      {/* begin::Footer */}
      {/*<div className='aside-footer flex-column-auto pt-5 pb-7 px-5' id='kt_aside_footer'>
        <a onClick={logout} className='btn btn-custom btn-primary w-100'>
          <i className="fa fa-sign-out-alt" />
          <span>Logout</span>
        </a>
      </div>*/}
      {/* end::Footer */}
    </div>
  )
}

export { AsideDefault }
